<template>
  <span>
    <a-modal title="批量修改" :visible="visible" :ok-button-props="{ props: { loading: loading } }" @cancel="visible = false" @ok="onSubmit">
      <a-form-model ref="form" :rules="rules" :model="form" :label-col="{ span: 5 }" :wrapper-col="{ span: 18 }">
        <a-form-model-item label="修改对象" prop="target">
          <a-radio-group v-model="form.target" @change="targetChange">
            <a-radio-button v-for="item in targetOptions" :key="item.value" :value="item.value"> {{ item.label }} </a-radio-button>
          </a-radio-group>
        </a-form-model-item>
        <a-form-model-item v-if="form.target === 'status'" label="状态" prop="value">
          <a-select v-model="form.value" style="width: 100%" @change="valueChange">
            <a-select-option v-for="(item, index) in caseStatus" :key="index" :value="item.value"> {{ item.label }} </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item v-else-if="form.target === 'module_id'" label="所属模块" prop="value">
          <a-tree-select v-model="form.value" show-search :filter-tree-node="filterModule" :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }" placeholder="请选择所属目录" :tree-data="moduleData" tree-default-expand-all @change="valueChange" />
        </a-form-model-item>
        <a-form-model-item v-else-if="form.target === 'priority'" label="优先级" prop="value">
          <a-select v-model="form.value" style="width: 100%" @change="valueChange">
            <a-select-option v-for="(item, key) in casePrioritys" :key="key" :value="item.value">
              <a-tag :color="item.color"> {{ item.label }} </a-tag>
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item v-else-if="form.target === 'tags'" label="用例标签">
          <a-select v-model="form.value" mode="multiple" style="width: 100%" @change="valueChange">
            <a-select-option v-for="(item, index) in tagData" :key="index" :value="item.id">
              {{ item.name }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item v-else-if="form.target === 'project_id'" label="项目" prop="value">
          <a-select v-model="form.value" style="width: 100%" show-search placeholder="请选择项目" :filter-option="utils.filterOption" @change="valueChange">
            <a-select-option v-for="(item, index) in projectData" :key="index" :value="item.id">
              {{ item.name }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
      </a-form-model>
    </a-modal>
    <a-tooltip title="批量编辑">
      <a-button v-tc="{ name: '批量编辑' }" type="primary" icon="edit" @click="onbatchEdit" />
    </a-tooltip>
  </span>
</template>
<script>
import { tagList } from '@/api/system/tag';
import { projectList } from '@/api/project/project';
import { caseStatus, casePrioritys } from '@/utils/dictionary';
import { caseBatchUpdate, moduleList } from '@/api/project/case';
export default {
  props: {
    checked: {
      type: Array,
      default: () => {
        return [];
      }
    }
  },
  data() {
    return {
      caseStatus,
      casePrioritys,
      loading: false,
      form: {
        value: null,
        target: 'status'
      },
      visible: false,
      projectId: parseInt(this.$route.params.project_id) || null,
      targetOptions: [
        { value: 'status', label: '状态' },
        { value: 'module_id', label: '所属模块' },
        { value: 'priority', label: '优先级' },
        { value: 'tags', label: '标签' },
        { value: 'project_id', label: '项目' }
      ],
      projectData: [],
      moduleData: [],
      rules: {
        target: [{ required: true, message: '修改目标不能为空', trigger: 'blur' }],
        value: [{ required: true, message: '不能为空', trigger: 'blur' }]
      },
      tagData: []
    };
  },
  methods: {
    // 获取标签列表
    getTagList() {
      tagList({ group_code: 'case' }).then(res => {
        this.tagData = res.data.items;
      });
    },
    // 点击批量修改
    onbatchEdit() {
      if (this.checked.length > 0) {
        this.visible = true;
        this.form = {
          value: null,
          target: 'status'
        };
      } else {
        this.$message.warning('请选择需要操作的用例');
      }
    },

    // target变更时的回调
    targetChange() {
      this.form.value = null;
      if (this.form.target === 'module_id' && this.moduleData.length === 0) {
        this.getModuleList();
      }
      if (this.form.target === 'tags' && this.tagData.length === 0) {
        this.form.value = [];
        this.getTagList();
      }
      if (this.form.target === 'project_id' && this.projectData.length === 0) {
        this.getProjectList();
      }
    },

    // value变更时的回调
    valueChange() {
      this.$refs.form.validateField(['value']);
    },

    // 模块筛选
    filterModule(searchValue, treeNode) {
      return treeNode.data.props.title.includes(searchValue);
    },

    // 获取模块列表
    getModuleList() {
      moduleList({ project_id: this.projectId, return_type: 'tree' }).then(res => {
        this.moduleData = [{ id: 0, key: 0, value: 0, title: '未分配', name: '未分配', scopedSlots: { title: 'title' }, children: [] }, ...res.data.items];
      });
    },

    // 获取项目列表
    getProjectList() {
      projectList({ page: 1, page_size: 1000 }).then(res => {
        this.projectData = res.data.projects;
      });
    },

    onSubmit() {
      this.loading = true;
      this.$refs.form.validate(valid => {
        if (valid) {
          caseBatchUpdate({ project_id: this.projectId, case_ids: this.checked, ...this.form })
            .then(() => {
              this.loading = false;
              this.visible = false;
              this.$emit('close');
            })
            .catch(() => {
              this.loading = false;
            });
        }
      });
    }
  }
};
</script>
